module.exports = __webpack_public_path__ + "static/media/logo.876c6e21.png";